module.exports = __webpack_public_path__ + "static/img/pass.124fcbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pass.png
// module id = wQ4G
// module chunks = 0